import {
  FETCH_HOLIDAYS_REQUEST, FETCH_HOLIDAYS_SUCCESS, FETCH_HOLIDAYS_FAIL,
} from "../../constants/Leave/HolidayConstants";

const initialState = { loading: false, data: [], error: null };

const HolidayReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_HOLIDAYS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_HOLIDAYS_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case FETCH_HOLIDAYS_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default HolidayReducer;